const SetBgColor = () => {
  const elements = [...document.querySelectorAll('[data-bg]')];

  if (elements.length > 0) {
    elements.forEach(element => {
      const bgColor = element.getAttribute('data-bg');
      element.style.backgroundColor = bgColor;
    });
  }
}

export default SetBgColor;